<template>
    <v-form>
        <v-text-field id="input-mobile" :label="$t('login.mobile')" type="number" prepend-icon="$phone"
            v-model="form.mobile" :error-messages="errors.mobile" />
        <v-text-field id="input-passcode" :label="$t('login.passcode')" type="text" prepend-icon="$passcode"
            v-model="form.passcode" :error-messages="errors.passcode">
            <template v-slot:append>
                <v-btn outlined color="primary" v-if="!freeze" @click="sendCode" style="width: 110px">
                    {{ $t('login.send_passcode') }}
                </v-btn>
                <v-btn v-else disabled>
                    <vue-countdown :time="freezeTime" :interval="500" @end="onFreezeEnd">
                        <template slot-scope="props">
                            <template v-if="props.seconds >= 1">
                                {{ props.seconds }}
                            </template>
                        </template>
                    </vue-countdown>
                </v-btn>
            </template>
        </v-text-field>
        <v-btn id="btn-loginmobile" color="primary" block large @click="confirm">{{ $t('login.confirm') }}
        </v-btn>
    </v-form>
</template>

<script>
import CaptchaInput from '../common/CaptchaInput.vue'
import validator from 'validator'
import VueCountdown from '@chenfengyuan/vue-countdown'
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import { useVisitorStore } from '@/stores/visitor'
import { mapActions } from 'pinia'

export default {
    setup: () => ({ v$: useVuelidate() }),
    validations: {
        form: {
            mobile: { required },
            // captchainput: { required },
            passcode: { required }
        }
    },
    data() {
        return {
            form: {
                mobile: '',
                // captchainput: '',
                passcode: ''
            },
            captchaimg: null,
            errors: {},
            freeze: false,
            freezeTime: 60000
        }
    },
    mounted() {
        // this.refreshCaptcha()
    },
    methods: {
        onFreezeEnd() {
            this.freeze = false
        },
        refreshCaptcha() {
            this.$api.auth.refreshCaptcha((res) => {
                this.captchaimg = res
            })
        },
        sendCode() {
            if (!validator.isMobilePhone(this.form.mobile, 'zh-CN')) {
                this.errors = { mobile: this.$t('errors.mobile_invalid') }
                return
            }
            // if (validator.trim(this.form.captchainput) === '') {
            // 	this.errors = {captchainput:this.$t('errors.CAPTCHA_REQUIRED')}
            //     return
            // }
            this.$api.auth.sendCode(
                this.form.mobile,
                '', // this.form.captchainput,
                function (resp) {
                    alert(resp)
                }
            )
        },
        ...mapActions(useVisitorStore, ['mobileLogin']),
        confirm() {
            this.mobileLogin(this.form)
                .then((r) => {
                    this.form = {
                        mobile: '',
                        // captchainput: '',
                        passcode: ''
                    }
                    this.$emit('success', r)
                    console.log('aaaaa')
                })
                .catch((e) => {
                    //如果后端报错（验证码或短信验证码错误），需要刷新captcha
                    this.errors = e.message
                    this.$emit('error', this.errors)
                })
        }
    },
    computed: {
        showpasscode() {
            return (
                validator.trim(this.form.mobile) !== ''
                // && validator.trim(this.form.captchainput) !== ''
            )
        }
    },
    components: {
        CaptchaInput,
        VueCountdown
    }
}
</script>
